const getScreenSize = () => {
  const width = window.innerWidth || document.body.clientWidth;
  const height = window.innerHeight || document.body.clientHeight;

  return { width, height };
};

export { getScreenSize };
